export const EmployeeRoles = [
  { label: 'Manager', value: 'M' },
  { label: 'Employee', value: 'E' },
];

export const EmployeeSalaryUnit = [
  { label: 'Month', value: 'M' },
  { label: 'Hour', value: 'H' },
];
